import {
  FormattedPlanDetails,
  OpenMessageType,
  PromoCodePlansPricesType,
  SubscriptionDuration,
  UserProperties,
} from "@shared/types";

export enum MessageType {
  WEBVIEW_READY = "webview_ready",
  BIOMETRIC_LOGIN_REQUEST = "biometric_login_request",
  INITIATE_PAYMENT_REQUEST = "initiate_payment_request",
  SHARE_REQUEST = "share_request",
  CONSOLE = "console",
  TRIGGER_SAVE_BIOMETRICS = "trigger_save_biometrics",
  GET_BIOMETRIC_DATA = "biometric_data_request",
  TOGGLE_USER_BIOMETRIC = "toggle_user_biometric",
  USER_UPDATED = "user_updated",
  OPEN_AUTH_SESSION = "open_auth_session",
  LEAVE_REVIEW = "leave_review",
  REQUEST_INTERCOM_ACTION = "request_intercom_action",
  REQUEST_CLIPBOARD_DATA = "request_clipboard_data",
  THEME_UPDATED = "theme_updated",
  NAVIGATE_BACK_REQUEST = "navigate_back_request",
  NAVIGATION_REQUEST = "navigation_request",
  NOTIFICATION_NAVIGATION_REQUEST = "notification_navigation_request",
  OPEN_MESSAGE = "open_message",
  RESPONSE = "response",
}

export interface BiometricsData {
  available?: boolean;
  enabled?: boolean;
}

export interface LoginCredentials {
  email?: string;
  password?: string;
}

export interface SaveBiometricsRequest extends LoginCredentials {
  rememberMe?: boolean;
}

export type UserBiometricsData = {
  biometricsEnabled: boolean;
  hasSavedBiometrics: boolean;
};

export interface MobileLoginData extends LoginCredentials {
  mobile_identifier?: string;
  unique_identifier?: string;
}

export type PaymentDetails = {
  plan?: FormattedPlanDetails;
  duration?: SubscriptionDuration;
  promoCode?: string;
  promoCodePrices?: PromoCodePlansPricesType;
};

export interface PaymentResult {
  transactionId: string;
  status: "completed" | "failed" | "pending";
  error?: string;
}

export interface ShareContent {
  url?: string;
  title?: string;
}

export interface ShareResult {
  shared: boolean;
  activityType?: string;
}

export interface CanGoBackResponse {
  canGoBack: boolean;
}

export interface NavigationRequest {
  pathname: string;
}

export interface MessageDetails {
  text: string;
  type: OpenMessageType;
  duration?: number;
}

export enum IntercomActionType {
  UPDATE,
  SHOW_SPACE,
  SHOW_ARTICLE,
  SHOW,
}

export interface IntercomAction {
  type: IntercomActionType;
  itemId?: string;
}

export interface ThemeUpdatedData {
  isDarkMode: boolean;
}

export interface ClipboardData {
  clipboardText?: string;
}

export type MessagePayload =
  | LoginCredentials
  | PaymentDetails
  | PaymentResult
  | ShareContent
  | ShareResult
  | CanGoBackResponse
  | NavigationRequest
  | UserProperties
  | MessageDetails
  | IntercomAction
  | ThemeUpdatedData
  | ClipboardData
  | { [key: string]: any };

export enum MessageStatus {
  SUCCESS = "success",
  ERROR = "error",
}
export interface BridgeMessage<T = MessagePayload> {
  id: string;
  type: MessageType;
  payload?: T;
  status?: MessageStatus;
  error?: string;
}

export interface PromiseCallbacks<T = any> {
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: any) => void;
}
